import { useMemo } from 'react'

import { Divider, StyledStep, StepCount, StepCountSeparator } from './Style'

type Props = {
  step: number
  text: string
  activeStep: number
  isAirdropComplete: boolean
}

export function Step({ text, step, activeStep, isAirdropComplete }: Props) {
  const showDivider = useMemo(() => step < 2, [step])

  const isActive = useMemo(() => {
    if (isAirdropComplete) {
      return false
    }

    return activeStep === step
  }, [step, activeStep, isAirdropComplete])

  const isCompleted = useMemo(() => {
    if (isAirdropComplete) {
      return true
    }

    return step < activeStep
  }, [step, activeStep, isAirdropComplete])

  return (
    <>
      <StyledStep completed={isCompleted} active={isActive}>
        <StepCount>
          {step + 1}
          <StepCountSeparator>-</StepCountSeparator>
        </StepCount>
        {text}
      </StyledStep>

      {showDivider ? <Divider>==&gt;</Divider> : null}
    </>
  )
}
